import { Component, h, Prop } from '@stencil/core';

@Component({
    tag: 'rentware-item-error',
    styleUrl: 'style.sass',
    shadow: true,
})
export class RentwareItemError {
    @Prop() message?: string;
    @Prop() hideClose = false;
    @Prop() onCloseClick: () => void;

    render() {
        const msg = this.message ?? 'Error: try again later'

        return (
            <div class="ItemErrorContainer">
                <span>{msg}</span>

                {!this.hideClose &&
                <div
                    class="ItemErrorCloseContainer"
                    onClick={this.onCloseClick}
                >
                    <span>
                        X
                    </span>
                </div>
                }
            </div>
        )
    }
}
